<template>
  <div id="versionLockout"> 
    
    <div class="center-parent">
      <div class="dialog-box">

        <div class="icon">
          <v-icon large>mdi-download</v-icon>
        </div>
        <div class="title">UPDATE REQUIRED</div>

        <div class="context large">This version of Vilio ({{ version }}) is no longer supported.</div>
    
        <br>

        <div class="context" v-if="platform !== 'web'">Please update your app via the
          <span class="link main-text" v-if="platform == 'android'" @click="forceUpdateLink('android')">Google Play Store</span><span class="link" v-if=platform != 'android' @click="forceUpdateLink('ios')">Apple App Store</span>.
        </div>
    
        <div class="context" v-if="platform === 'web'">Please refresh your browser to get the latest version of Vilio.<br><br>If you are still receiving this message, please try <span class="link" @click="forceUpdateLink('clearcache')">clearing your cache.</span></div>

      </div>
    </div>

  </div>
</template>

<script>

  export default {

    computed: {

      platform () {
        return window.cordova ? window.cordova.platformId : 'web'; 
      },

      version () {
        return VERSION;
      }

    },

    methods: {

      forceUpdateLink (link) {
        window.open(APP_URL + '/' + link);
      }

    }
  }

</script>

<style lang="scss" scoped>

  @import '../css/global.scss';

  #versionLockout {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: $primary;

    .center-parent {

      .dialog-box {
        position: relative;
        max-width: 650px;
        min-width: 400px;
        margin: 0 auto;
        background: $white;
        text-align: center;
        padding: 16px;
        box-shadow: $cardShadow;

        .icon {
          margin: 0 0 8px;
        }

        .title {
          @include fontPrimary500();
          @include title();

          font-size: 24px;
          color: $black54; 
          margin: 0 0 24px;
        }

        .context {
          font-size: 16px;
          color: $black54;
        }

        .link {
          color: $primary;
          cursor: pointer;
          text-decoration: underline;
        }
      }
    }

    @media screen and (max-width: 550px) {
      .center-parent {

        .dialog-box {
          min-width: 0px;
          width: calc(100% - 32px);
        }

      }
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/VersionLockout.vue